import React from 'react';
import './footer.css'

function Footer () {
    return (
        <div>
        <footer className='footer'>
       <h6 className='save-footer'> © 2026 SỞ CÔNG THƯƠNG TỈNH AN GIANG. Tất cả quyền được bảo lưu.</h6>
      </footer>
        </div>
    )

};

export default Footer;